import type { LocationQuery, Router } from 'vue-router'
import { initConfig } from './utils'
import { initFetch } from './fetch'
import { PageEnum } from '@/enums/pageEnum'
import { useStorage } from '@/hooks/system/useStorage'
import { useUserStoreWithOut } from '@/store/modules/user'
import { EGlobalConfig } from '@/enums/cacheEnum'
import { removeHtmlLoading } from '@/layouts/hooks/useLayout'

const LOGIN_PATH = PageEnum.BASE_LOGIN
const whitePathList: PageEnum[] = [LOGIN_PATH, '/demo/index', '/building', '/loginout']
const userStore = useUserStoreWithOut()

const { getConfig } = initConfig()

export function createPermissionGuard(router: Router) {
  router.beforeEach(async (to, from, next) => {
    const TOKEN = useStorage.ls.get(EGlobalConfig.token)
    const APISRC = useStorage.ls.get(EGlobalConfig.apiSrc)
    const PUSHSRC = useStorage.ls.get(EGlobalConfig.pushSrc)

    const isLogin = !!(TOKEN && APISRC && PUSHSRC) || userStore.isLoginOut
    const isLoginParams = to.query.token || to.query.apiSrc || to.query.pushSrc

    // 从 url 上读取参数
    const queryFilter = (await getConfig(isLogin)) as LocationQuery

    if (whitePathList.includes(to.path as PageEnum)) {
      removeHtmlLoading()
      if (to.path === LOGIN_PATH && (isLogin)) {
        next({ path: (to.query?.redirect as string) || PageEnum.BASE_HOME, query: queryFilter })
        return
      }

      next()
      return
    }

    if (!isLogin) {
      const redirectData: { path: string; replace: boolean; query?: LocationQuery } = {
        path: LOGIN_PATH,
        replace: true,
        query: queryFilter,
      }
      if (to.path) {
        redirectData.query = {
          ...redirectData.query,
          redirect: to.path,
        }
      }
      next(redirectData)
      return
    } else if (isLoginParams) {
      // 清除 url 上的 token apiSrc pushSrc
      next({
        path: to.path,
        query: queryFilter,
      })
      return
    }

    if (!userStore.account) {
      await initFetch(to)
    }

    const redirectPath = (from.query.redirect || to.path) as string
    const redirect = decodeURIComponent(redirectPath)

    if (to.path === redirect) {
      next()
    } else {
      next({ path: redirect, query: queryFilter })
    }
  })
}
